import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAPIResponse, IUser } from "../../types/api";
import { alertActions } from "../alert/alertSlice";
import { getUsers as getUsersFromAPI } from "../../lib/api";

interface IGetUsersResponse extends IAPIResponse {
    users: IUser[];
}

export const getUsers = createAsyncThunk<
    IGetUsersResponse,
    void,
    { rejectValue: string }
>("user/getUsers", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getUsersFromAPI();
        // console.log(response);

        return response;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "User retrieval failed. Please try again",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});
